module.exports = __webpack_public_path__ + "media/images/entry/entry_btn1-0f6dcba7d75aaedf3208755eb806e8ce.gif";